import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Button, Dropdown } from 'react-bootstrap';
import countryCodes from './countryCodes';
import { fetchOTPdata, fetchVerify, fetchLogin, fetchGeneralSetting } from './Api';
import bgImg from '../images/login-backgrd.jpeg';
import logo1 from '../images/mahuadesi.png';
import gmail from '../images/gmail-logo.jpg';
import { GoogleAuthProvider, signInWithPopup, onAuthStateChanged } from 'firebase/auth';
import { auth } from '../firebase';
import Cookies from 'js-cookie';
import { Contextone } from './Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import globalSetting from "../configuration.js";
import { counter } from '@fortawesome/fontawesome-svg-core';
import MailLogin from './MailLogin.jsx';

const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = timeInSeconds % 60;
    const formattedMinutes = String(minutes).padStart(2, '0');
    const formattedSeconds = String(seconds).padStart(2, '0');
    return `${formattedMinutes}:${formattedSeconds} s`;
};

const MobileLogin = ({handleShowContent}) => { const [countryCode, setCountryCode] = useState(countryCodes[0].value);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [email, setEmail] = useState("");
    const [isLoginType, setLoginType] = useState("mobile");
    const [isGeneralSetting, setGeneralSetting] = useState([]);
    const [isEmailSetting, setEmailSetting] = useState("");
    const [isMobileSetting, setMobileSetting] = useState("");
    const [customLogo, setCustomLogo] = useState("");
    const [Otp, setOtp] = useState(new Array(4).fill(""));
    const [otpStep, setOtpStep] = useState(false);
    const [uid, setUserId] = useState(0);
    const [verify, setVerify] = useState([]);
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [countdown, setCountdown] = useState(30);
    const [isResendDisabled, setIsResendDisabled] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");
    const [invalidnumber, setInvalidnumber] = useState("");
    const host = window.location.host;
    const counterContext = useContext(Contextone);
    const history = useHistory();
    const inputRefs = useRef([]);
    const logo = counterContext.isLogo
    const isurl = counterContext.isDomain;
    const apiUrl = `https://${isurl}`;

    const goBack = () => {
        if (otpStep) {
            setOtp(new Array(4).fill(""));
            setOtpStep(false);
            setIsOtpSent(false);
            setErrorMessage(false)
        }
        else {
            history.goBack();
        }
    };

    const googleProvider = new GoogleAuthProvider();
    googleProvider.setCustomParameters({
        prompt: 'select_account'
    });

    const prevLoc = Cookies.get('loc');

    useEffect(() => {
        let timer;
        if (isOtpSent && countdown > 0) {
            timer = setTimeout(() => {
                setCountdown((prevCountdown) => prevCountdown - 1);
            }, 1000);
        } else if (countdown === 0) {
            setIsResendDisabled(false);
        }

        return () => clearTimeout(timer);
    }, [isOtpSent, countdown]);

    const handlePhoneSubmit = (e) => {
        e.preventDefault();
        if (phoneNumber.length !== 10) {
            setInvalidnumber("Phone number must be 10 digits.");
            return;
        }

        if (/^[0-5]/.test(phoneNumber)) {
            setInvalidnumber("Enter a valid mobile number.");
            return;
        }

        fetchOTP(phoneNumber, email, isLoginType);
        setOtpStep(true);
        setIsOtpSent(true);
        setIsResendDisabled(true);
        setCountdown(30);
    };

    const handleOtpSubmit = (e) => {
        e.preventDefault();
        if (Otp.some((digit) => digit === "")) {
            setErrorMessage("OTP must be 4 digits.");
            return;
        }
        const otpValue = Otp.join("");
        verifyData(countryCode, phoneNumber,email, otpValue);
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !Otp[index] && index > 0) {
            const newOtp = [...Otp];
            newOtp[index - 1] = "";
            setOtp(newOtp);
            inputRefs.current[index - 1].focus();
        }
    };

    const handleChange = (element, index, e) => {
        const value = element.value;
        if (/^[0-9]$/.test(value)) {
            const newOtp = [...Otp];
            newOtp[index] = value;
            setOtp(newOtp);

            if (index < Otp.length - 1) {
                inputRefs.current[index + 1].focus();
            }
        } else if (e.nativeEvent.inputType === "deleteContentBackward") {
            const newOtp = [...Otp];
            newOtp[index] = "";
            setOtp(newOtp);
        }
    };

    const handlePhoneNumberChange = (e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value)) {
            setPhoneNumber(value);
        }
    };

    const login = () => {
        signInWithPopup(auth, googleProvider).catch(error => {
            console.error('Login Error:', error);
        });
    };

    onAuthStateChanged(auth, (user) => {
        if (user) {
            handleLogin(user.email);
        }});

    const handleLogin = async (email) => {
        try {
            const data = await fetchLogin(apiUrl,2, email);
            setUserId(data.result[0].id);
            localStorage.setItem('userid', data.result[0].id);
            Cookies.set('userid', data.result[0].id);
            counterContext.setIsLogged(true);
            counterContext.setIsLogOutButton(false);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    useEffect(() => {
        const fetchSetting = async () => {
          try {
            const data = await fetchGeneralSetting(apiUrl);
            setGeneralSetting(data.result);
          } catch (error) {
            console.error("Error:", error);
          }
        };
        fetchSetting();
      }, []);

    const fetchOTP = async (phoneNumber, email, isLoginType) => {
        const pNumber = phoneNumber ? `${countryCode}${phoneNumber}` : phoneNumber;
        try {
            const data = await fetchOTPdata(apiUrl,pNumber, email, isLoginType);
        } catch (error) {
            console.error('Error:', error);
        }
    };

    const verifyData = async (countryCode, phoneNumber, email, otp) => {
        try {
            const data = await fetchVerify(apiUrl,countryCode + phoneNumber, email, otp);
            if (data.status === 200) {
                setUserId(data.result.id);
                localStorage.setItem('userid', data.result.id);
                Cookies.set('userid', data.result.id);
                localStorage.setItem('userPhone', data.result.mobile);
                counterContext.setIsLogged(true);
                counterContext.setIsLogOutButton(false);
                // history.push('/home');
            } else {
                setErrorMessage("Incorrect OTP entered. Please enter again.");
                setOtp(new Array(4).fill(""));
                inputRefs.current[0].focus();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };

    if (uid) {
        counterContext.setIsLogged(true);
        counterContext.setIsLogOutButton(false);
        // history.push('/home');
        history.push(`${prevLoc}`)
    }

    useEffect(() => {
        if (Array.isArray(isGeneralSetting)) {
            isGeneralSetting.forEach((mtype) => {
            if(mtype.key === 'is_email' && mtype.value === "1"){
                setEmailSetting(mtype.value)
                // setLoginType("email")
            }
            else if(mtype.key === 'is_mobile' && mtype.value === "1"){
                setMobileSetting(mtype.value);
            }
            else if(mtype.key === 'custom_logo_css' && mtype.value !== ''){
                setCustomLogo(mtype.value)
            }
          });
        }
      }, [isGeneralSetting]);
    
      let val = customLogo.split(";")    
      val = val.map(item => item.trim()).filter(Boolean);
      let cssProperties = {};
      
      val.forEach(item => {
        let [property, value] = item.split(":").map(str => str.trim());
        cssProperties[property] = value;
      });
    
      const logoElement = document.querySelector('.signin-logo img');
    
      if(customLogo && window.innerWidth <= 768){
        for (let property in cssProperties) {
          logoElement.style[property] = cssProperties[property];
        }
      }

    return (
        <>
            {/* {!counterContext.isSwitchEmail &&  */}
                <div className="signin-container">
                <div className="signin-background">
                    <img src={bgImg} alt="Background" className="background-image" />
                </div>
                <div className="signin-form-container">
                     <div className="signin-form">
                        <button onClick={goBack} style={{ background: 'none', marginLeft: '0px', border: 'none', fontSize: '24px', color: '#000', cursor: 'pointer', position: 'relative',right: '2vw', bottom: '4vh'}}>
                            <FontAwesomeIcon icon={faArrowLeft} style={{ color: 'white' }} />
                        </button>
                        <div className="signin-logo">
                            <img src={logo} alt="Logo" />
                        </div>
                        <h2 style={{ fontSize: '24px', marginTop: '15px' }} className={otpStep ? "otp-heading" : ""}>
                            {otpStep ? "Enter your 4 digit OTP" : "Log In"}
                        </h2>

                        <Form onSubmit={otpStep ? handleOtpSubmit : handlePhoneSubmit}>
                            {otpStep ? (
                                <>
                                    <Form.Group className="otp-group">
                                        {Otp.map((data, index) => (
                                            <Form.Control
                                                key={index}
                                                type="text"
                                                name="otp"
                                                maxLength="1"
                                                className="otp-input"
                                                value={data}
                                                onChange={(e) => handleChange(e.target, index, e)}
                                                onKeyDown={(e) => handleKeyDown(e, index)}
                                                ref={(el) => (inputRefs.current[index] = el)}
                                            />
                                        ))}
                                    </Form.Group>
                                    <div>
                                        {errorMessage && (
                                            <span className="error-messages">{errorMessage}</span>
                                        )}
                                    </div>
                                </>
                            ) : (
                                 
                                   
                                <Form.Group>
                                <div className="input-group">
                                    <Dropdown className='country-code'>
                                        <Dropdown.Toggle className='country' variant="secondary" id="dropdown-basic">
                                            {countryCode}
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className="custom-dropdown-menu" >
                                            {countryCodes.map((code) => (
                                                <Dropdown.Item
                                                    key={code.value}
                                                    onClick={() => setCountryCode(code.value)}
                                                >
                                                    {code.label}
                                                </Dropdown.Item>
                                            ))}
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <Form.Control
                                        type="text"
                                        id="mobile"
                                        value={phoneNumber}
                                        onChange={handlePhoneNumberChange}
                                        placeholder="Mobile Number"
                                        maxLength={10}
                                        required
                                    />
                                </div>
                                <div>
                                    {invalidnumber && (
                                        <span className="error-messages">{invalidnumber}</span>
                                    )}
                                </div>
                            </Form.Group>

                            )}
                            {/* <Button type="submit" className="signIn-button btn btn-danger btn-block"> */}
                            <Button type="submit" className="signIn-button btn-block">
                                {otpStep ? "Verify OTP" : "Send OTP"}
                            </Button>
                        </Form>
                        {!isOtpSent && (isurl === 'mahuaplay.ottsnap.in' || isurl === 'admin.aaryaadigital.com') && (
                            <>
                                <div className="text-center mt-2">
                                    <span>OR</span>
                                </div>
                                
                                    <div className="gmailContainer mt-2">
                                        <button className="gmailButton" onClick={() => login()}>
                                            <img className="gmailImg" src={gmail} alt="" loading="lazy" />
                                            <span className='googletext'>Log in with Google</span>
                                        </button>
                                    </div>
                                
                            </>
                        )}
                         {isEmailSetting && isMobileSetting && (
                            <Button
                                type="submit"
                                // className="signIn-button btn btn-danger btn-block"
                                className="signIn-button btn btn-danger btn-block"
                                onClick={() => handleShowContent('mail')}
                            >
                                Login with Email
                        </Button>
                        )}

                        {/* {counterContext.isSwitchEmail && <MailLogin />} */}

                        {isOtpSent && (
                            <div className="gmailContainer mt-3">
                                <a
                                    style={{ cursor: isResendDisabled ? 'context-menu' : 'pointer', color: 'white' }}
                                    disabled={isResendDisabled}
                                    onClick={() => {
                                        if (!isResendDisabled) {
                                            fetchOTP(phoneNumber, email, isLoginType);
                                            setCountdown(30);
                                            setIsResendDisabled(true);
                                        }
                                    }}
                                >
                                    Resend OTP {isResendDisabled && formatTime(countdown)}
                                </a>
                            </div>
                        )}
                    </div> 
                </div>
            </div>
            {/* } */}
        </>
    );
};


export default MobileLogin;
